// extracted by mini-css-extract-plugin
module.exports = {"rating":"default-module__rating___1k45X"};